export default function About() {
	return (
		<>
			<div id="about-content">
				<h1>About The Scratch Channel</h1>
				<p>
					We are a group of Scratch journalists, not affiliated with
					the Scratch Team or LLK, writing articles about Scratch on
					here. This is the team:
				</p>
				<h3>Developers:</h3>
				<ul>
					<li>
						Nouxinf <a href="https://github.com/nouxinf">Github</a>,{" "}
						<a href="https://scratch.mit.edu/users/SmartCat3/">
							Scratch
						</a>
					</li>
					<li>
						Polylogue{" "}
						<a href="https://github.com/polylogue2">Github</a>,{" "}
						<a href="https://scratch.mit.edu/users/Swiftpixel/">
							Scratch
						</a>
					</li>
					<li>
						Supervoidcoder{" "}
						<a href="https://github.com/supervoidcoder">Github</a>,{" "}
						<a href="https://scratch.mit.edu/users/scratchcode1_2_3/">
							Scratch
						</a>
					</li>
					<li>
						kRxZy_kRxZy{" "}
						<a href="https://github.com/kRxZykRxZy">Github</a>,{" "}
						<a href="https://scratch.mit.edu/users/kRxZy_kRxZy/">
							Scratch
						</a>
					</li>
				</ul>
				<h3>Writers:</h3>
				<ul>
					<li>
						Gvyt <a href="https://github.com/Gvyt">Github</a>,{" "}
						<a href="https://scratch.mit.edu/users/GvYoutube/">
							Scratch
						</a>
					</li>
					<li>
						Snoopythe3{" "}
						<a href="https://github.com/snoopythe3-from-scratch">
							Github
						</a>
						,{" "}
						<a href="https://scratch.mit.edu/users/snoopythe3/">
							Scratch
						</a>
					</li>
				</ul>

				<p>
					Our codebase is licensed under the MIT License, meaning you
					can do whatever you want with the code as long as you
					include the same LICENSE file, which you can find{" "}
					<a href="https://cdn.jsdelivr.net/gh/The-Scratch-Channel/the-scratch-channel.github.io@refs/heads/main/LICENSE">
						here
					</a>
					.
				</p>
				<h3>Attribution</h3>
				<ul>
					<li>
						Flag icons licensed{" "}
						<a href="https://creativecommons.org/licenses/by/4.0/deed.en">
							CC BY 4.0
						</a>
						, made by Twitter
					</li>
				</ul>
			</div>
		</>
	);
}
